import React from 'react'
import classNames from 'classnames'
import { NAVBAR_DROPDOWN_ID } from '../../../../constants/navigation'
import { TriangleSvg } from '../../../../svgs'
import BaseDropdown from '../../Dropdown'
import { List } from '../List'
import styles from './Dropdown.module.scss'
import { DropdownProvider, useDropdownContext } from './DropdownContext'

export interface DropdownProps {
  label: string
  dropdownClassName?: string
  listClassName?: string
  isSelected?: boolean
  children: React.ReactNode
}

const NavbarDropdown = ({ label, isSelected, children, dropdownClassName, listClassName }: DropdownProps) => {
  const { open, setIsOpen, isLightThemeType } = useDropdownContext()

  const buttonProps = {
    label,
    onMouseEnter: () => setIsOpen(true),
    onFocus: () => setIsOpen(true),
    id: NAVBAR_DROPDOWN_ID,
    'aria-expanded': open,
    className: classNames(styles.button, {
      [styles.dropdownIsOpen]: open,
      [styles.dropdownItemIsActive]: isSelected,
      [styles.lightTheme]: isLightThemeType
    }),
    iconEnd: TriangleSvg
  }

  const dropdownToggleProps = {
    className: styles.dropdownToggle
  }

  return (
    <div tabIndex={-1} className={styles.wrapper} onMouseLeave={() => setIsOpen(false)}>
      <BaseDropdown
        className={classNames(styles.dropdown, dropdownClassName)}
        buttonProps={buttonProps}
        dropdownToggleProps={dropdownToggleProps}
        segmentedDropdown={false}
        open={open}
        setOpen={setIsOpen}
      >
        <div tabIndex={-1} className={styles.triangle} />
        <List aria-labelledby={NAVBAR_DROPDOWN_ID} className={classNames(styles.list, listClassName)}>
          {children}
        </List>
      </BaseDropdown>
    </div>
  )
}

export const Dropdown = props => {
  return (
    <DropdownProvider>
      <NavbarDropdown {...props} />
    </DropdownProvider>
  )
}
